<template>
  <div class="layout">

         <router-view></router-view>

  </div>
</template>

<script>
  // 引入拖拽组件
  export default {
    name: 'demo',
    components: {

    },
    data () {
      return {


      }
    },
    methods:{

    }
  }
</script>
<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/Home.vue